'use client';
import React from 'react';
import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';
import PrimaryButton from '@/app/_components/buttons/primary-button/PrimaryButton';

import '@/app/_styles/index.scss';
import styles from './notFound.module.scss';

export default function NotFound() {
  const { data: session } = useSession();

  const router = useRouter();

  const backClickHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    router.back();
  };

  const navigateClickHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    router.push('/about');
  };

  return (
    <main className={styles.notFoundMain}>
      <section className={styles.inner}>
        <h1>404 Page Not Found</h1>
        <h2>Ooops..</h2>
        <p>Could not find requested page</p>
        <div className={styles.navigationWrapper}>
          {session && (
            <PrimaryButton
              label="To About page"
              disabled={false}
              onClick={(e) => navigateClickHandler(e)}
            />
          )}

          <PrimaryButton
            label="Back"
            disabled={false}
            onClick={(e) => backClickHandler(e)}
          />
        </div>
      </section>
    </main>
  );
}
